import { FeatureFlagProvider } from '../../components/FeatureFlag/FeatureFlagProvider';
import { ThemeContext } from '../contexts/ThemeContext';
import { PricingModuleContextProvider } from '../contexts/PricingModuleContext';
import { CombinedContextProvider } from '../helpers/CombinedContextProvider';
import { ShowstopperProvider } from '../contexts/ShowstopperProvider';
import { TowerLayoutProvider } from '../../TowerLayout/TowerLayoutProvider';
import { UserProvider } from '../contexts/UserContext/UserContext';
import { AppDrawerProvider } from '../../components/AppDrawer/AppDrawerProvider';
import { QueryClientProvider } from '../contexts/QueryClientProvider';
import { SassRestrictionsProvider } from '../contexts/SassRestrictionsContext';

const Contexts = CombinedContextProvider(
    QueryClientProvider,
    FeatureFlagProvider,
    ThemeContext,
    PricingModuleContextProvider,
    SassRestrictionsProvider,
    ShowstopperProvider,
    TowerLayoutProvider,
    UserProvider,
    AppDrawerProvider
);

export default function SiteContextWrapper({ children }: { children: React.ReactNode }) {
    return <Contexts>{children}</Contexts>;
}
